import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html'

import { type QuillOpType } from '@/defs/misc'
import { escapeHtml } from '@/utils/commonUtil'

type Props = {
  deltaOps: QuillOpType[]
}

export const parseQuillDelta = ({ deltaOps }: Props) => {
  const converter = new QuillDeltaToHtmlConverter(deltaOps)

  converter.renderCustomWith((customOp) => {
    if (customOp.insert.type !== 'card-link') return ''

    const name = escapeHtml(customOp.insert.value)
    return `<span class="edhrecp__link"><a class="edhrecp__link-a" content="${name}" href="#" target="_blank">${name}</a></span>`
  })

  return converter.convert()
}
